<script lang="ts">
	import Shape from '#components/shape.svelte'
	import Render from '#components/render.svelte'
	import type { StoryblokAsset, StoryblokRichtext } from '#library/components.schema.build.ts'

	interface Props {
		suptitle?: string
		title?: string
		body?: StoryblokRichtext
		image?: StoryblokAsset
		theme?: string
		inline?: boolean
		count?: number
		i?: number
		shape?: string
	}

	let {
		suptitle,
		title,
		body,
		image,
		theme,
		inline = undefined,
		count,
		i = 0,
		shape = '6_5-02'
	}: Props = $props()
</script>

<div class="card {theme}" class:inline>
	{#if image?.filename}
		<Shape src={image.filename} alt={title} name={(shape || '6_5-02') as never} focus={image.focus} />
	{/if}
	<div>
		{#if suptitle}
			<div class="suptitle">{suptitle.replace('{{pagination}}', `${i + 1} of ${count}`)}</div>
		{/if}
		{#if title}
			<div class="title">{title}</div>
		{/if}
		{#if body}
			<div class="body">
				<Render content={body} />
				{#if i >= 0 && count}
					<div class="pagination">
						<span>{String(i + 1).padStart(2, '0')}</span> / {String(count).padStart(2, '0')}
					</div>
				{/if}
			</div>
		{/if}
	</div>
</div>

<style lang="css">
	.card {
		align-self: stretch;
		align-items: center;
		background-color: var(--c-background);
		color: var(--c-foreground);
		display: grid;
		gap: 2rem;
		margin-inline-start: 2.5%;
		padding: 2rem;
		scale: var(--scale);
		width: 95%;

		@media (--from-mobile) {
			grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
			gap: 3.25rem;
			margin-inline-start: 0;
			padding: 3rem 4rem;
			width: auto;
		}
	}

	.suptitle {
		font: 500 var(--f-h6);
		letter-spacing: var(--ls-h6);
		text-transform: uppercase;
	}

	.title {
		font: 500 var(--f-h3);
		letter-spacing: var(--ls-h3);
	}

	.body {
		color: var(--c-midground);
		font: 400 var(--f-body1);
		letter-spacing: var(--ls-body1);

		:global(a) {
			color: var(--c-foreground);
			font-weight: 500;
		}
	}

	.pagination {
		font: 400 var(--f-body2);
		letter-spacing: var(--ls-body2);
		margin-block-start: 1.5rem;

		span {
			font: 400 var(--f-h4);
			letter-spacing: var(--ls-h4);
		}
	}
</style>
